export function getAssetParams(isAuthenticated, subdomain, sponsorId) {
  if (isAuthenticated) {
    return sponsorId ? { sponsorId } : {};
  }
  return {
    subdomain,
  };
}
